import React, { useEffect, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../Utils/AuthContext";
import { TeamsMoneyFunctions } from "../Utils/TFunctions";
import Posts from "./Posts/Posts";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Forum.css";
import { Row, Col, Container } from "react-bootstrap";

function Forum() {
  const { name, email } = useAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [pathName, setPathName] = useState(false);
  const { loadPosts, openPostModal } = TeamsMoneyFunctions({ pathName });
  const navigate = useNavigate();
  const routerLocation = useLocation();

  useEffect(() => {
    if (email && name) {
      setIsAuthenticated(true);
      setPathName(routerLocation.pathname);
    } else {
      setIsAuthenticated(false);
      setPathName(routerLocation.pathname);
    }
  }, [email, name]);

  useEffect(() => {
    loadPosts();
  }, []);

  useEffect(() => {
    const createPostButton = document.querySelector("#createPostButton");

    const handleCreatePostButtonClick = () => {
      if (!isAuthenticated) {
        alert("You must be signed in to create a post. Please sign in or sign up.");
        navigate("/login", { state: { from: routerLocation.pathname } });
      } else {
        openPostModal();
      }
    };

    if (createPostButton) {
      createPostButton.addEventListener("click", handleCreatePostButtonClick);

      return () => {
        createPostButton.removeEventListener(
          "click",
          handleCreatePostButtonClick
        );
      };
    }
  }, [isAuthenticated, openPostModal, navigate]);

  return (
    <div className="forum-page">
      <Container style={{ width: "100%" }}>
        <Row style={{ height: "10px" }}></Row>
        <Posts />
      </Container>
    </div>
  );
}

export default Forum;
